<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content fluid fill-height>
      <HeaderSimple />
      <v-stepper v-model="e1" class="elevation-0">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="e1 > 1" step="1">Informações de Login</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :editable="edit" :complete="e1 > 2" step="2">Dados Pessoais</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Formas de Contato</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-5">
                        <v-text-field
                          solo
                          flat
                          label="Email"
                          v-model="email"
                          :rules="emailRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Confirme o seu Email"
                          v-model="check_email"
                          :rules="emailConfirmationRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelPassword')"
                          v-model="password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          :rules="passwordRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelConfirmPassword')"
                          v-model="check_password"
                          :append-icon="show2 ? 'visibility' : 'visibility_off'"
                          :type="show2 ? 'text' : 'password'"
                          @click:append="show2 = !show2"
                          :rules="senhaConfirmationRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-checkbox
                        v-model="checkbox"
                        required
                        :rules="[(v) => !!v || 'Você deve aceitar os Termos de Uso e Política de Privacidade para continuar.']"
                      >
                        <template v-slot:label>
                          <div>
                            Li e aceito os
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a target="_blank" href="/termo" @click.stop v-on="on">Termos de Uso</a>
                              </template>
                              {{$t('pageCadastro.tooltipAba')}}
                            </v-tooltip>e a
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a
                                  target="_blank"
                                  href="/privacidade"
                                  @click.stop
                                  v-on="on"
                                >Política de Privacidade</a>
                              </template>
                              {{$t('pageCadastro.tooltipAba')}}
                            </v-tooltip>
                          </div>
                        </template>
                      </v-checkbox>
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="verifyEmail"
                        :disabled="!valid"
                      >CONTINUAR</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-4 ma-0 pa-0">
                <ButtonFoto
                  title="Foto de Perfil"
                  v-bind:email="email"
                  v-on:url-img="saveImgProfile"
                  folder="paciente"
                  name_img="profileImg"
                />
                <v-select
                  :items="list_language"
                  label="Idioma"
                  @change="getLanguage"
                  :rules="rules"
                  required
                  solo
                  flat
                  background-color="#F7F7F7"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid2" ref="form2">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          label="Sexo"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>
                        <v-row class="flex-colum">
                          <v-col class="col-4">
                            <v-select
                              :items="['NIF', 'CPF']"
                              v-model="defaultFicalId"
                              :rules="rules"
                              @change="getFiscal_id"
                              required
                              solo
                              flat
                              background-color="#F7F7F7"
                            ></v-select>
                          </v-col>
                          <v-col class="col-8">
                            <v-text-field
                              solo
                              flat
                              :label="defaultFicalId"
                              v-mask="mask"
                              v-model="fiscal_id"
                              :rules="rules"
                              required
                              background-color="#F7F7F7"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <DatePicker v-on:date="saveDate" />
                        <v-text-field
                          solo
                          flat
                          label="Número de Telefone"
                          v-model="tel"
                          :rules="rules"
                          type="tel"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <div>
                          <h2 class="primary--text mb-3">Endereço</h2>
                        </div>
                        <v-text-field
                          solo
                          flat
                          label="Nacionalidade"
                          v-model="nation"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Cidade"
                          v-model="city"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelDestrito')"
                          v-model="state"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-autocomplete
                          solo
                          flat
                          hide-no-data
                          clearable
                          label="Fuso horário"
                          :items="time_zone"
                          @change="timeZone"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="stage2()"
                        :disabled="!valid2"
                      >CONTINUAR</v-btn>
                    </v-row>
                    <v-row class="align-center justify-center">
                      <v-col class="col-10 col-md-8">
                        <v-alert
                          v-model="isMenor"
                          type="warning"
                          dismissible
                        >Você necessita enviar a autorização de um responsável por email. caso não envie, não poderá realizar consultas no Ondivan.</v-alert>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <div>
                          <h2 class="primary--text">Suas informações de contato</h2>
                        </div>
                        <v-text-field
                          solo
                          flat
                          label="WhatsApp"
                          v-model="Whatsapp"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Hangouts"
                          v-model="Hangouts"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Facebook Messenger"
                          v-model="Facebook"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Skype"
                          v-model="Skype"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <div>
                          <h2 class="primary--text">Contato Emergencial</h2>
                          <p
                            class="font-italic"
                          >Só iremos contactar essa pessoa em caso de urgência.</p>
                        </div>
                        <v-text-field
                          solo
                          flat
                          label="Nome"
                          v-model="contact_name"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Email"
                          v-model="contact_email"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Telefone"
                          v-model="contact_tel"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="submit"
                        :disabled="!valid"
                        :loading="loader"
                      >FINALIZAR</v-btn>
                      <v-btn text to="login">Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import HeaderSimple from '@/components/HeaderSimple';
import ButtonFoto from '@/components/ButtonFoto';
import DatePicker from '@/components/DatePicker';
import http from '@/services/httpClient';
import moment from 'moment-timezone';
import { mask } from 'vue-the-mask';
import i18n from '../../plugins/i18n';

export default {
  components: {
    HeaderSimple,
    ButtonFoto,
    DatePicker,
  },
  directives: {
    mask,
  },
  data: () => ({
    valid: false,
    valid2: false,
    show1: false,
    show2: false,
    loader: false,
    edit: false,
    e1: 1,
    photo_profile: '',
    name: '',
    list_gender: ['Masculino', 'Feminino', 'Não Definido'],
    gender: '',
    list_language: [
      {
        text: 'PT-BR',
        value: 'pt-BR',
      },
      {
        text: 'PT',
        value: 'pt',
      },
    ],
    language: '',
    defaultFicalId: 'NIF',
    fiscal_id: '',
    mask: '### ### ###',
    date_birth: '',
    nation: '',
    city: '',
    state: '',
    tel: '',
    time_zone: moment.tz.names(),
    time_offset: '',
    time_zone_name: '',
    contact_name: '',
    contact_tel: '',
    contact_email: '',
    Whatsapp: '',
    Hangouts: '',
    Facebook: '',
    Skype: '',
    email: '',
    check_email: '',
    password: '',
    check_password: '',
    checkbox: false,
    rules: [v => !!v || 'Esse campo é obrigatório'],
    emailRules: [
      v => !!v || 'Email é obrigatório',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
        || 'Email está invalido',
    ],
    passwordRules: [
      v => !!v || 'A senha é obrigatória',
      v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
        || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
    ],
    snackbar: false,
    msg: '',
    isMenor: false,
  }),

  computed: {
    emailConfirmationRules() {
      return [
        v => !!v || 'Email é obrigatório',
        () => this.email === this.check_email
          || 'Email não corresponde com o informado anteriormente.',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
          || 'Email está invalido',
      ];
    },

    senhaConfirmationRules() {
      return [
        v => !!v || 'A senha é obrigatória',
        () => this.password === this.check_password
          || 'A Senha não corresponde com a informada anteriormente.',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
          || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
      ];
    },
  },

  watch: {
    language(val) {
      i18n.locale = val;
    },
  },

  methods: {
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    getLanguage(v) {
      this.language = v;
    },
    stage2() {
      if (this.defaultFicalId == 'CPF') {
        if (this.validaCPF(this.fiscal_id.replace(/(\.|\/|\-)/g, ''))) {
          this.e1 = 3;
          this.edit = true;
        } else {
          this.msg = 'CPF inválido, favor adicionar um CPF válido!';
          this.snackbar = true;
        }
      } else if (this.defaultFicalId == 'NIF') {
        if (this.validateNIF(this.fiscal_id.replace(/ /g, ''))) {
          this.e1 = 3;
          this.edit = true;
        } else {
          this.msg = 'NIF inválido, favor adicionar um NIF válido!';
          this.snackbar = true;
        }
      }
    },

    verifyEmail() {
      http
        .post('/users/check_username/', {
          username: this.email,
        })
        .then((response) => {
          console.log(response.data);
          // this.e1 = 2;
          this.msg = response.data;
          this.snackbar = true;
        })
        .catch((err) => {
          console.log(err.response.data.detail);
          this.e1 = 2;
        });
    },

    getGender(v) {
      this.gender = v;
    },
    getFiscal_id(v) {
      this.defaultFicalId = v;
      if (v == 'CPF') {
        this.mask = '###.###.###-##';
      } else {
        this.mask = '### ### ###';
      }
    },

    async submit() {
      if (
        this.Whatsapp == ''
        && this.Hangouts == ''
        && this.Facebook == ''
        && this.Skype == ''
      ) {
        this.msg = 'Preencha ao menos um campo de contato!';
        this.snackbar = true;
      } else if (this.$refs.form.validate()) {
        this.loader = true;
        await this.signUp();
      }
    },
    /**
     * Função que envia todos os dados do paciente para fazer o cadastro dele no sistema.
     */
    signUp() {
      http
        .post('/patients/', {
          name: this.name,
          photo: this.photo_profile,
          gender: this.gender,
          date_birth: this.date_birth,
          country: this.nation,
          city: this.city,
          state: this.state,
          telephone: this.tel,
          fiscal_id:
            this.defaultFicalId == 'CPF'
              ? this.fiscal_id.replace(/(\.|\/|\-)/g, '')
              : this.fiscal_id.replace(/ /g, ''),
          whatsapp: this.Whatsapp,
          messenger: this.Hangouts,
          hangouts: this.Facebook,
          skype: this.Skype,
          contact_name: this.contact_name,
          contact_email: this.contact_email,
          contact_telephone: this.contact_tel,
          time_zone: this.time_offset,
          time_zone_name: this.time_zone_name,
          email: this.email,
          password: this.password,
          confirm_password: this.check_password,
        })
        .then((response) => {
          this.snackbar = true;
          this.msg = 'Cadastro Realizado com sucesso!';
          setTimeout(() => {
            this.$router.replace('login');
          }, 3000);
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.email) {
            this.snackbar = true;
            this.msg = err.response.data.email;
          }
        })
        .finally(() => (this.loader = false));
    },

    gettanggal(str) {
      if (str != null) {
        return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(
          0,
          4,
        )}`;
      }
      return '';
    },

    saveImgProfile(value) {
      this.photo_profile = value;
    },

    saveDate(value) {
      const dateNow = new Date();
      const baseYear = dateNow.getFullYear() - 18;
      const userYear = value.slice(0, 4);
      if (userYear > baseYear) {
        // verifica se o ano quer usuario escolheu é maior que o ano base
        this.isMenor = true;
      } else if (baseYear == userYear) {
        if (value.slice(5, 7) > dateNow.getMonth()) {
          this.isMenor = true;
        } else if (value.slice(5, 7) == dateNow.getMonth()) {
          if (value.slice(9, 10) < dateNow.getDate()) {
            this.isMenor = true;
          }
        }
      }
      this.date_birth = value;
    },

    // VALIDAÇÃO CPF
    validaCPF(cpf) {
      let numeros;
      let digitos;
      let soma;
      let i;
      let resultado;
      let digitos_iguais;
      digitos_iguais = 1;
      if (cpf.length < 11) return false;
      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) != cpf.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      }
      if (!digitos_iguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;
        return true;
      }
      return false;
    },

    // VALIDAÇÃO NIF
    validateNIF(nif) {
      if (nif.length == 9) {
        let added;
        let control;
        let mod;

        added = nif[7] * 2
          + nif[6] * 3
          + nif[5] * 4
          + nif[4] * 5
          + nif[3] * 6
          + nif[2] * 7
          + nif[1] * 8
          + nif[0] * 9;
        mod = added % 11;
        if (mod == 0 || mod == 1) {
          control = 0;
        } else {
          control = 11 - mod;
        }

        if (nif[8] == control) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
};
</script>
